@if (dualLists) {
  <div #header class="header" id="edx_list_picker_header">
    <div class="libwrapper" [ngClass]="{web:userInterface===0,desktop:userInterface===1}">
      <edx-select class="inlineselect" [items]="libSelItems" [id]="'edx_lib_selector'" [value]="displayLibName()" (change)="libChanged($event)"></edx-select>
    </div>
    @for (crumb of crumbs; track crumb; let isLast = $last; let isFirst = $first) {
      <div class="crumb" title="{{crumb.name}}" [ngClass]="{last:isLast,first:isFirst}">
        <span tabindex="0" [attr.aria-label]="breadCrumbText+' '+crumb.DOCNAME" (keyup.enter)="crumbClicked(crumb)" (keydown.space)="crumbClicked(crumb)" (click)="crumbClicked(crumb)">{{crumb.DOCNAME}}</span>
        <img [ngClass]="{last:isLast}" src="assets/images/caret_right12.svg">
      </div>
    }
  </div>
}
<div class="container" [style.height]="containerHeight()" [ngClass]="{expandleft:splitAction===1, expandright:splitAction===2, collapseleft:splitAction===3, collapseright:splitAction===4, shiftleft:splitAction===5, shiftright:splitAction===6}" (animationend)="animationComplete()" id="edx_list_picker_body">
  @if (dualLists) {
    <div class="parentparentlist">
      <div class="listtitle">{{desc.DOCNAME}}</div>
      <div class="listcontainer"></div>
    </div>
  }
  <div class="parentlist" [ngClass]="{shrunk:splitView}" id="edx_list_picker_parentlist" tabindex="0" (keyup.arrowright)="focusOnList('edx_list_picker_childlist')">
    @if (showMobileFilter && canShowCreateContainer()) {
      <button class="createcontainer mobile secondary" [ngClass]="{oai:isAddin}" (click)="createContainerClick()" id="edx_list_picker_btnchild_create">{{createContainerStr}}</button>
    }
    @if (dualLists) {
      <div class="listtitle">{{desc.DOCNAME}}</div>
    }
    @if (showMobileFilter && canSearchFilter()) {
      <edx-search-filter #filter [desc]="child.desc" [list]="this" [asFilter]="true" [showFilterMenu]="showFilterMenu"></edx-search-filter>
    }
    <div class="listcontainer" [ngClass]="{duallists:dualLists,oaifilters:isAddin&&canSearchFilter()&&showMobileFilter}" (keydown)="onKeyDown($event, true)">
      @if (!singleSelect&&showSelectAll(getList())) {
        <div class="selectall">
          <div class="selector" role="checkbox" [attr.aria-checked]="allSelected?'true':somethingSelected?'mixed':'false'" [attr.aria-label]="isChrome?(allSelected?selectAll:selectAll+' '):selectAll" [ngClass]="{partialselect:somethingSelected, allselect:allSelected}" (click)="toggleAllParents($event)" (keydown.space)="toggleAllParents($event)" id="edx_list_picker_selectall" tabindex="0"></div>
          <div class="name">{{selectAll}}</div>
        </div>
      }
      @for (item of getList(); track item; let i = $index) {
        @if (canAddToLeft(item)) {
          <div class="item" id="{{ 'edx_list_folder_selector_parent_' + i }}" [ngClass]="{selected:selectedList.indexOf(item)>=0,open:(item.type===child.desc.type&&item.id===child.desc.id&&item.lib===child.desc.lib)}" tabindex="0" (keydown.space)="parentItemClicked(item,$event)" (click)="parentItemClicked(item)" role="row" [attr.aria-label]="item.ignoreTypeOnFocus?item.DOCNAME: getLabel(item,true)">
            @if (canSelectItem(item)) {
              <div class="selector" role="checkbox" [attr.aria-checked]="selectedList.indexOf(item)>=0" [attr.aria-label]="isChrome?(selectedList.indexOf(item)>=0?item.DOCNAME:item.DOCNAME+' '):item.DOCNAME" tabindex="0" (keydown.space)="toggleSelected($event,'parent',item)" (click)="toggleSelected($event,'parent',item)"></div>
            }
            @if (!canSelectItem(item)) {
              <div class="selector disabled"></div>
            }
            <img class="icon" src="{{getIconSrc(item)}}" alt="{{getIconText(item)}}">
            @if (displayMiniStatus(item, 'APP_ID')) {
              <img class="overlaystatusicon" src="{{formatStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
            }
            @if (displayTopMiniStatus(item, 'APP_ID')) {
              <img class="overlaystatusicon top" src="{{formatTopStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
            }
            <div class="name" title="{{getTooltip(item)}}" tabindex="0" (keydown.space)="parentItemClicked(item,$event)">{{item.DOCNAME}}</div>
          </div>
        }
      }
      @if (canShowMore()) {
        <div class="showmore">
          <button [ngClass]="{mobile:userInterface>=2, oai:isAddin}" (click)="fetchMoreItems()" id="edx_list_picker_btnparent_loadmore">{{loadMore}}</button>
        </div>
      }
    </div>
  </div>
  @if (dualLists) {
    <div class="childlist" [ngClass]="{expanded:splitView}" id="edx_list_picker_childlist" [tabindex]="splitView ? 0 : -1" (keyup.arrowleft)="focusOnList('edx_list_picker_parentlist')">
      @if (!phoneLook && canShowCreateContainer()) {
        <button [tabindex]="splitView ? 0 : -1" class="createcontainer secondary" (click)="createContainerClick()" id="edx_list_picker_btnchild_create">{{createContainerStr}}</button>
      }
      <div class="listtitle">{{child.desc.DOCNAME}}</div>
      @if (!phoneLook && canSearchFilter()) {
        <edx-search-filter #filter [desc]="child.desc" [list]="this" [asFilter]="true" [hideFilter]="!splitView" [showFilterMenu]="showFilterMenu"></edx-search-filter>
      }
      @if (showChildSelectAll()) {
        <div class="selectall">
          @if (pickDocs && !singleSelect) {
            <div class="selector" role="checkbox" [attr.aria-checked]="child.allSelected?'true':child.somethingSelected?'mixed':'false'" [attr.aria-label]="child.allSelected?selectAll:selectAll+' '" [ngClass]="{partialselect:child.somethingSelected, allselect:child.allSelected}" tabindex="0" (keydown.space)="toggleAllChildren($event)" (click)="toggleAllChildren($event)"></div>
            <div class="name">{{selectAll}}</div>
          }
        </div>
      }
      <div class="listcontainer" [ngClass]="{duallists:dualLists, selectshown:showChildSelectAll(), filtershown:canSearchFilter()}" (keydown)="onKeyDown($event, false)">
        @for (item of child.list; track item; let i = $index) {
          <div class="item" id="{{ 'edx_list_folder_selector_' + i }}" [ngClass]="{selected:child.selectedList.indexOf(item)>=0}" tabindex="0" (keydown.space)="childItemClicked(item,$event)" (click)="childItemClicked(item)" role="row" [attr.aria-label]=getLabel(item)>
            @if (pickDocs || pickDocsOnly || pickFilePart || originalType === 'filepartworkspaces') {
              @if (canSelectItem(item)) {
                <div class="selector" role="checkbox" [attr.aria-checked]="child.selectedList.indexOf(item)>=0" [attr.aria-label]="isChrome?(child.selectedList.indexOf(item)>=0?item.DOCNAME:item.DOCNAME+' '):item.DOCNAME" tabindex="0" (keydown.space)="toggleSelected($event,'child',item)"  (click)="toggleSelected($event,'child',item)"></div>
              }
              @if (!canSelectItem(item)) {
                <div class="selector disabled"></div>
              }
            }
            <img class="icon" src="{{getIconSrc(item)}}" alt="{{getTypeText(item)}}">
            @if (displayMiniStatus(item, 'APP_ID')) {
              <img class="overlaystatusicon" [ngClass]="{hasselector:pickDocs||pickDocsOnly||pickFilePart}" src="{{formatStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
            }
            @if (displayTopMiniStatus(item, 'APP_ID')) {
              <img class="overlaystatusicon top" [ngClass]="{hasselector:pickDocs||pickDocsOnly||pickFilePart}" src="{{formatTopStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
            }
            @if (isTwoLine(item)) {
              <div class="namewrapper twoline" tabindex="0" title="{{getTooltip(item)}}" (keydown.space)="childItemClicked(item,$event)">
                <div class="name">{{item.DOCNAME}}</div>
                <div class="name docnum">{{item.id}}</div>
              </div>
            }
            @if (!isTwoLine(item)) {
              <div class="namewrapper" tabindex="0" title="{{getTooltip(item)}}" (keydown.space)="childItemClicked(item,$event)">
                <div class="name">{{item.DOCNAME}}</div>
              </div>
            }
          </div>
        }
        @if ((pageSizeIncremental) > 0 && !child.allItemsIn && (child.list.length > 0)) {
          <div class="showmore">
            <button [ngClass]="{mobile:userInterface>=2, oai:isAddin}" (click)="fetchMoreChildItems()" id="edx_list_picker_btnchild_loadmore">{{loadMore}}</button>
          </div>
        }
      </div>
    </div>
  }
  @if (dualLists) {
    <div class="childchildlist">
      <div class="listtitle">{{child.desc.DOCNAME}}</div>
      <div class="listcontainer"></div>
    </div>
  }
</div>
@if (reloading) {
  <edx-spinner></edx-spinner>
}
